export default {
    init() {
        // JavaScript to be fired on all pages

        // ScrollTo Menu
        $('.js-scrollTo a, .js-scrollTo').on('click', function () { // Au clic sur un élément
            var target = $(this).attr('href'); // Page cible
            var speed = 750; // Durée de l'animation (en ms)
            $('html, body').animate({ scrollTop: $(target).offset().top - 50 }, speed); // Go
            return false;
        });

        $(".menu-item a").on('click', function () {
            $('.navbar-collapse').collapse('hide'); 
        });

        $('#slickRef').slick();

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js